import { render, staticRenderFns } from "./shopPagination.vue?vue&type=template&id=6a92228f&scoped=true&"
import script from "./shopPagination.vue?vue&type=script&lang=js&"
export * from "./shopPagination.vue?vue&type=script&lang=js&"
import style0 from "./shopPagination.vue?vue&type=style&index=0&id=6a92228f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a92228f",
  null
  
)

export default component.exports